var Labels = function(){

    'use strict';

    var instances = [],
    $ = jQuery;

    function onReady() {
        $('.module.labels').each(function () {
            instances.push(initInstance($(this)));
        });
    }

    function initInstance(view) {
        var $view = view,
        id = $view.data('id');

        var Instance = {
            init: function () {
               
            }
        }

        Instance.init();

        return Instance;
    }

    // Subscribe to WINDO_LOADED event
    jQuery(onReady);

}

Labels();
